import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class NavigationResetMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('NavigationResetMessage', NavigationResetMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');